import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
  Button,
  Card,
  Image,
  List,
  Popup,
  PopupContent,
} from 'semantic-ui-react';
import { userLanguage } from '../../../app/common/userLanguageSchema/userLanguage';
import LoadingComponent from '../../../app/layout/LoadingComponent';
import { useStore } from '../../../app/stores/store';
import MicroLoader from '../Details/VideoandAudioComponent/MicroTaggingDropdown/MicroLoader';
import { Activity } from './../../../app/models/activity';
import MediaAssetListAvatar from './MediaAssetListAvatar';

interface Props {
  activity: Activity;
}

function MediaAssetListItem({ activity }: Props) {
  const { activityStore, userStore, commonStore } = useStore();
  const { user } = userStore;
  const { loadingInitial } = activityStore;

  useEffect(() => {}, [activity, activity?.assignedUsers]);

  if (loadingInitial || !activity) return <LoadingComponent />;
  return (
    <>
      {user?.displayName && (
        <Card
          style={{
            display: 'inline-block',
            margin: '2pt',
            width: '200pt',
          }}
        >
          {activity.thumbnail ? (
            <Image
              loading="lazy"
              style={{
                height: '395px',
                width: 'auto',
                margin: 'auto',
              }}
              src={activity.thumbnail}
              onError={(img: any) => (img.target.src = '/assets/thumbnail.png')}
            />
          ) : (
            <Image
              loading="lazy"
              style={{
                height: '395px',
                width: 'auto',
              }}
              src={'/assets/thumbnail.png'}
              onError={(img: any) => (img.target.src = '/assets/thumbnail.png')}
            />
          )}
          <Card.Content>
            <List horizontal>
              <List.Item>
                <MediaAssetListAvatar activity={activity?.assignedUsers} />
              </List.Item>
            </List>
            <Button
              as={Link}
              to={`/mediaAssets/${activity.id}`}
              color="grey"
              floated="right"
              content={
                (userLanguage[0].AssetViewItemLevelListPage.AVIB13 as any)?.[
                  `${commonStore.language.key}`
                ]
              }
            />
          </Card.Content>
          {activityStore.peopleData && <MicroLoader id={activity.id} />}
          {/* {activityStore.objectData&&<MicroLoader id={activity.id} peopleTimeLine={objectTimeLine}/>} */}
          <Card.Content className="textmovietruncate">
            <Popup
              hoverable
              key={activity.id}
              trigger={<strong>{activity.title}</strong>}
            >
              <PopupContent>
                <strong>{activity.title}</strong>
              </PopupContent>
            </Popup>
          </Card.Content>
        </Card>
      )}
    </>
  );
}
export default observer(MediaAssetListItem);
